export default __webpack_public_path__ + "static/list-selections-17fcf40dad827bdeeed56d2b85cd43f8.mp4";